<script>
	let name = 'joseph';
	let count = 0;
	let increment = 1;

	function handleClick() {
		count += increment
	}

	$: multiplier = `x${increment}`;
	$: threePower = count ** 3;
	$: console.log(`the values of your cookies to the power of three
	is equal to: ${threePower}`);
	$: switch (count) {

		case 10: case 50: case 100: case 250: case 505: case 667: case 778: 
		case 1002:  case 2002: case 3002: case 5002: case 10002: case 50002:
		case 60002: case 70002: case 80002: case 90002:
		alert(`Congrats, you have reached the ${count} cookie milestone`);
		break;

		case 200:
		alert("DOUBLE MULTIPLIER ACTIVATED!!!")
		increment = 2;
		break;

		case 400:
		alert("TRIPLE MULTIPLIER ACTIVATED!!!");
		increment = 3;
		break;

		case 802:
		alert("QUADRUPLE MULTIPLIER ACTIVATED!!!")
		increment = 4;
		break;

		case 4002:
		alert("10x MULTIPLIER ACTIVATED!!! OH MAI GOD!!")
		increment = 10;
		break;

		case 9002:
		alert("25x MULTIPLIER ACTIVATED!!! DAMN SONN!!!")
		increment = 25;
		break;
		
		case 40002:
		alert("50x MULTIPLIER ACTIVATED!!! UR UNSTOPPABLE!!!")
		increment = 50;
		break;

		case 100002:
		alert("Holy shet you have reached the 100 002 cookie milestone. You need to get a life man....");
		increment = 99999999999999;
		break;
	}
</script>

<style>
	.box-one {
		width: 50vw;
		margin: 60px auto;
		text-align: center;
		border: 1px solid red;
		padding: 60px;
	}

	h1 {
		font-size: 50px;
		display: block;
	}

	p {
		line-height: 22px;
		font-size: 20px;
	}

	button {
		background: white;
		padding: 35px 45px;
		margin: 50px 0px 30px 0px;
		font-size: 35px;
	}

	.multiplier {
		color: red;
	}
</style>

<div class="box-one">
<h1>Hello {name}! <span class="multiplier"> {multiplier} </span> </h1>
<p>Mein name is UWU here i am going to make  a beautiful APP!!! HEHEHE
	wot mate just happened bro lmao wtf. what guy?
</p>
<button on:click={handleClick}>
{count} {count === 1 ? "cookie" : "cookies"}
</button>
</div>